module.exports = __webpack_public_path__ + "media/images/ellipsisw-09d3b334e7b53c86fd2ffe087394ba89.svg";